import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();

export default {
    name: "RecapSignAutprev",
     data () {
    return {
      resultCheckScan:null,        
      loading:false,
      token:null,
      callbackUrl:null,
      callbackLibelle:null

    }
  },
  beforeMount: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callbackUrl;
    this.callbackLibelle = this.$root.callbackLibelle;
    
  },

  methods: {
    signAutprevDocument: function(){
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      //set type de signature
      this.$globalService.setSessionSouscription('typeSignProgress','webflowsignautprev');  
      doccliService.webflowsignautprev(sessionSouscription.doccli_id).then(res => { 
          this.loading = false;
          if(res){
            if (res.err !='error') {
              this.$globalService.setSessionSouscription('webflow_signature_url',res.params.webflow_signature_url);  
              this.$globalService.setSessionSouscription('active_rdv',res.params.active_rdv);             
              
              this.$router.push({name: 'ProgressSign'});
             
                        
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      //this.$router.push({path: '/souscription/scandocuments'});
    }
  }
}